<template>
  <div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card v-can="'view-account-credit'" title="ACCOUNT CREDIT" class="pb-4">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }" v-if="isDataAvailable">
            <form @submit.prevent="handleSubmit(clickOnUpdateCreditAccount)" autocomplete="off">
              <div class="vx-row mb-3" v-if="accountCredit.account_type === 'credit'">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="credit_limit" name="credit_limit" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">
                    <small class="label">Credit Limit</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{__accountCurrency()}}</span>
                        </div>
                      </template>
                      <vs-input readonly v-model="accountCredit.credit_limit"   name="credit_limit" class=" required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="current_credit_amount" name="current_credit_amount" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">
                    <small class="label">Current Credit Amount</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{__accountCurrency()}}</span>
                        </div>
                      </template>
                      <vs-input readonly v-model="accountCredit.current_credit_amount"   name="current_credit_amount" class="w-full required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="account_type" name="account_type" rules="" v-slot="{ errors }">
                    <small class="label">Account Type</small>
                    <v-select disabled :clearable="false" placeholder="" v-model="accountCredit.account_type"  :options="['proforma','credit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="accountCredit.account_type === 'credit'">
                  <ValidationProvider vid="available_credit" name="available_credit" rules="required" v-slot="{ errors }">
                    <small class="label">Available Credit Amount</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{__accountCurrency()}}</span>
                        </div>
                      </template>
                      <vs-input readonly  v-model="accountCredit.available_credit"   name="available_credit" class="w-full required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                    <small class="label">Note</small>
                    <vs-textarea readonly class="mb-0" v-model="accountCredit.note" height="100px" />
                  </ValidationProvider>
                </div>
              </div>

            </form>
          </ValidationObserver>
        </vx-card>
      </div>
    </div>

    <customer-account-limit-request :account_type="accountCredit.account_type"/>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CustomerAccountLimitRequest from './CustomerAccountLimitRequest.vue'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'


  export default {
    name: 'AllUsersList',
    data () {
      return {
        customerId: '',
        accountCredit: {},
        isDataAvailable: false
      }
    },
    components: {
      'v-select': vSelect,
      CustomerAccountLimitRequest
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      await this.fetchCustomerAccountCredit()
    },
    methods: {
      async refreshData () {
        await this.fetchCustomerAccountCredit()
      },

      async fetchCustomerAccountCredit(){
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit()
          this.accountCredit = data.data
          this.isDataAvailable = true
        } catch (e) {
          // this.convertAndNotifyError(e)
          this.isDataAvailable = false
        }
        this.$vs.loading.close()
      }
    },
    watch : {

    },
    computed: {
      requiredAndTwoDecimalRules() {
        if (this.accountCredit.account_type === 'proforma') {
          return ''
        } else {
          return 'required'
        }
      }
    }
  }
</script>


<style scoped>

</style>
